import { render, staticRenderFns } from "./price_table.vue?vue&type=template&id=51226ce8&scoped=true&"
import script from "./price_table.vue?vue&type=script&lang=js&"
export * from "./price_table.vue?vue&type=script&lang=js&"
import style0 from "./price_table.vue?vue&type=style&index=0&id=51226ce8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51226ce8",
  null
  
)

export default component.exports